<template>
  <div class="inventorycontainer">
    <div class="inventory" id="printTest" style="height: 100%">
      <div class="title">采购清单</div>
      <div class="infocontainer">
        <div class="info">
          <div class="infoTitle">
            <span class="xx">订单信息</span>
            <span>订单编号：{{ info.Number }}</span>
            <span>下单时间：{{ info.billdate }}</span>
          </div>
          <div class="infoContent">
            <div class="i-top clearfix">
              <div class="i-l">
                <ul>
                  <li>
                    <div class="name">收&nbsp;件&nbsp;人：</div>
                    <div class="content">{{ info.shperson }}</div>
                  </li>
                  <li>
                    <div class="name">联系方式：</div>
                    <div class="content">{{ info.shphone }}</div>
                  </li>
                  <li>
                    <div class="name">收货人区域：</div>
                    <div class="content">
                      {{ info.shadress }}
                    </div>
                  </li>
                  <li>
                    <div class="name">详细地址：</div>
                    <div class="content">
                      {{ info.sharea }}
                    </div>
                  </li>
                  <li>
                    <div class="name">备注：</div>
                    <div class="content">
                      {{ info.summary ? info.summary : "无" }}
                    </div>
                  </li>
                </ul>
              </div>
              <div class="i-r">
                <ul>
                  <li>
                    <div class="ti">商品合计:</div>
                    <div class="num">
                      ￥{{ parseFloat(info.Total).toFixed(2) }}
                    </div>
                  </li>
                  <li>
                    <div class="ti">税费:</div>
                    <div class="num">￥{{ parseFloat(taxes).toFixed(2) }}</div>
                  </li>
                  <li class="i-padd">
                    <div class="ti">邮费:</div>
                    <div class="num">
                      ￥{{ parseFloat(info.kdf).toFixed(2) }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="piceitem">
              <span
                >金额大写：
                <span class="c-s">
                  {{
                    this.$money.changeNumMoneyToChinese(
                      parseFloat(info.Total + taxes + info.kdf).toFixed(2)
                    )
                  }}
                </span>
              </span>
              <span
                >&nbsp;&nbsp;应付：
                <b
                  >￥{{
                    parseFloat(
                      parseFloat(info.Total) + taxes + parseFloat(info.kdf)
                    ).toFixed(2)
                  }}</b
                >
              </span>
            </div>
            <div class="i-bot clearfix">
              <div class="i-b-zi">{{ info.taxtype }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;物流信息：{{info.transtype? info.transtype:"暂无信息"}}&nbsp;&nbsp;&nbsp;&nbsp;{{info.kdnum}}</div>
              <div class="btn" v-print="'#printTest'">
                <i class="el-icon-document"></i>
                打印订单
              </div>
              <div
                class="btn"
                style="margin-right: 30px"
                @click="orderEdit(info.Number)"
                v-show="this.$route.query.type == 0"
              >
                订单修改
              </div>
              <div
                class="btn"
                style="margin-right: 30px"
                @click="payment(info.Number)"
                v-show="this.$route.query.type == 0"
              >
                立即付款
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="table">
        <div class="tableTitle">商品信息</div>
        <el-table :data="shopList" size="mini" stripe style="width: 100%">
          <el-table-column label="品牌">
            <template slot-scope="scope">
              <img :src="scope.row.imgurlpinpai" alt="" />
            </template>
          </el-table-column>
          <el-table-column label="图片">
            <template slot-scope="scope">
              <img :src="scope.row.imgurl" alt="" />
            </template>
          </el-table-column>
          <el-table-column label="名称" style="text-align: center">
            <template slot-scope="scope">
              <span>
                {{ scope.row.pfullname }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="材质">
            <template slot-scope="scope">
              <span>
                {{ scope.row.caizhi }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="标准">
            <template slot-scope="scope">
              <span>
                {{ scope.row.standerd }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="型号">
            <template slot-scope="scope">
              <span>
                {{ scope.row.xinghao }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="颜色">
            <template slot-scope="scope">
              <span>
                {{ scope.row.color }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="单价">
            <template slot-scope="scope">
              <span>
                {{ parseFloat(scope.row.price).toFixed(2) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="数量">
            <template slot-scope="scope">
              <span>{{ parseInt(scope.row.qty) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="金额">
            <template slot-scope="scope">
              ￥{{ parseFloat(scope.row.qty * scope.row.price).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column label="重量">
            <template slot-scope="scope">
              {{ parseFloat(scope.row.qty * scope.row.mweight).toFixed(2) }}g
            </template>
          </el-table-column>
        </el-table>
        <div class="tableFooter clearfix">
          <div class="pice">
            <div>合计</div>
            <div class="red">￥{{ parseFloat(num).toFixed(2) }}</div>
            <div class="red">
              {{ (parseFloat(weight) / 1000).toFixed(2) }}kg
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getbilldetail, getorderbill } from "@/api";
import { orderRouter } from "@/router";
export default {
  data() {
    return {
      shopList: [],
      num: 0,
      weight: 0,
      taxes: 0,
      info: {},
    };
  },
  methods: {
    orderEdit(Number) {
      this.$store.commit("changeNumberOdd", Number);
      this.$router.push({
        path: "/purchase",
        query: {
          Number,
        },
      });
    },
    payment(Number) {
      this.$router.addRoutes(orderRouter);
      this.$router.push({
        path: "/orderpay",
        query: {
          Number,
        },
      });
    },
    // 商品列表
    async getbilldetails(billno) {
      let usercode = window.sessionStorage.getItem("usercode");
      let token = window.sessionStorage.getItem("token");
      const { data: res } = await getbilldetail({ usercode, token, billno });
      this.shopList = JSON.parse(res);
      this.countAll();
    },
    // 订单信息
    async getorderbillIInfo(billno) {
      let usercode = window.sessionStorage.getItem("usercode");
      let token = window.sessionStorage.getItem("token");
      const { data: res } = await getorderbill({
        usercode,
        token,
        billno,
      });
      this.info = JSON.parse(res)[0];
      if (this.info.taxtype !== "无需开票") {
        this.taxes = this.info.Total * 0.08;
      } else {
        this.taxes = 0;
      }
    },
    countAll() {
      this.num = 0;
      this.weight = 0;
      this.shopList.forEach((ele, i) => {
        this.num += parseFloat(ele.qty) * parseFloat(ele.price);
        this.weight += parseFloat(ele.qty) * parseFloat(ele.mweight);
      });
    },
  },
  mounted() {
    this.getbilldetails(this.$route.query.Number);
    this.getorderbillIInfo(this.$route.query.Number);
  },
};
</script>
<style lang='less' scoped>
.inventory {
  width: 950px;
  margin: 0 auto;
  .table {
    margin: 20px 0;
    border: 1px solid #ccc;
    img {
      width: 35px;
    }
    .tableFooter {
      background: #f3f4f6;
      height: 40px;
      line-height: 40px;
      padding-right: 2px;
      .pice {
        display: flex;
        float: right;
        .red {
          color: #e3030d;
          font-size: 16px;
        }
        div {
          font-size: 14px;
          margin: 0 11px;
          text-align: center;
        }
      }
    }
  }
  .tableTitle {
    height: 40px;
    line-height: 40px;
    text-indent: 10px;
    background: #f3f4f6;
    border-bottom: 1px solid #ccc;
  }
  .infocontainer {
    border: 1px solid #cccccc;
    .info {
      .infoContent {
        padding: 15px 25px;
        .i-bot {
          height: 40px;
          line-height: 40px;
          .i-b-zi {
            float: left;
            color: #666666;
          }
          .btn {
            cursor: pointer;
            float: right;
            background: #e4040c;
            font-size: 14px;
            color: #fff;
            width: 110px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border-radius: 5px;
          }
        }
        .i-l {
          float: left;
          li {
            display: flex;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            .name {
              color: #666666;
            }
          }
        }
        .piceitem {
          padding: 20px 0;
          text-align: right;
          span {
            color: #6e6e6e;
          }
          .c-s {
            color: #000;
          }
          b {
            padding-left: 25px;
            font-size: 20px;
            color: #e5040b;
            font-weight: 600;
          }
        }
        .i-r {
          float: right;
          .i-padd {
            padding-bottom: 20px;
            border-bottom: 1px dashed #777777;
          }
          li {
            display: flex;
            height: 30px;
            line-height: 30px;
            justify-content: flex-end;
            .ti {
              color: #666666;
              width: 100px;
              text-align: end;
            }
            .num {
              width: 100px;
              text-align: right;
            }
          }
        }
      }
      .infoTitle {
        display: flex;
        height: 45px;
        line-height: 45px;
        background: #f3f4f6;
        border-bottom: 1px solid #cccccc;
        .xx {
          font-size: 16px;
          font-weight: 600;
          color: #666666;
          padding-left: 25px;
        }
        span {
          padding: 0 10px;
          color: #656668;
        }
      }
    }
  }
  .title {
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 16px;
  }
}
</style>